reSplitDetails